import React, { useMemo, useState } from "react";
import {
  FaUsers,
  FaTrailer,
} from "react-icons/fa";
import { GiGearStickPattern } from "react-icons/gi";
import { GoGear } from "react-icons/go";
import { PiEngineBold } from "react-icons/pi";
import { MdSnowmobile } from "react-icons/md";
import { RxRulerHorizontal } from "react-icons/rx";
import { PiGaugeThin } from "react-icons/pi";
import { IoMdBatteryCharging } from "react-icons/io";



import "../styles/vehicles.css";

/**
 * Edit this data only.  
 * - tiers: ["explorer","adventure","elite"] controls which memberships can access the unit
 * - category:
 *    "travelTrailers" | "boats" | "watercraft" | "atv" | "utv" | "golfCart" | "snowmobile"
 * - image: put a URL OR use a file in /public/images and reference like "/images/boat-1.jpg"
 */
const VEHICLES = [
  {
    id: "ATV1",
    name: "ATV - Compact",
    subtitle: "Kawasaki Brute Force Or Similar.",
    category: "atv",
    tiers: ["explore", "adventure", "elite"],
    tag: "Seats 1",
    image: "images/vehicles/BruteForce450.jpg",
    highlights: [
      { icon: PiEngineBold, text: "450cc" },
      { icon: GoGear, text: "4x4" },
      { icon: GiGearStickPattern, text: "Automatic" },
    ],
  },
  {
    id: "ATV2",
    name: "ATV - Compact",
    subtitle: "Yamaha Kodiak 450 Or Similar.",
    category: "atv",
    tiers: ["explore", "adventure", "elite"],
    tag: "Seats 1",
    image: "images/vehicles/kodiak450.png",
    highlights: [
      { icon: PiEngineBold, text: "450cc" },
      { icon: GoGear, text: "4x4" },
      { icon: GiGearStickPattern, text: "Automatic" },
    ],
  },
  {
    id: "ATV3",
    name: "ATV - Recreation",
    subtitle: "Yamaha Kodiak Or Similar.",
    category: "atv",
    tiers: ["adventure", "elite"],
    tag: "Power-Steering",
    image: "images/vehicles/kodiak700.png",
    highlights: [
      { icon: PiEngineBold, text: "700cc" },
      { icon: GoGear, text: "4x4" },
      { icon: GiGearStickPattern, text: "Automatic" },
    ],
  },
  {
    id: "ATV4",
    name: "ATV - Recreation",
    subtitle: "Kawasaki Brute Force Or Similar.",
    category: "atv",
    tiers: ["adventure", "elite"],
    tag: "Power-Steering",
    image: "images/vehicles/bruteforce750.jpg",
    highlights: [
      { icon: PiEngineBold, text: "750cc" },
      { icon: GoGear, text: "4x4" },
      { icon: GiGearStickPattern, text: "Automatic" },
    ],
  },
  {
    id: "ATV5",
    name: "ATV - Premium",
    subtitle: "Yamaha Grizzly Or Similar.",
    category: "atv",
    tiers: ["elite"],
    tag: "Fully Equipped",
    image: "images/vehicles/grizzly700.png",
    highlights: [
      { icon: PiEngineBold, text: "700cc" },
      { icon: GoGear, text: "4x4" },
      { icon: GiGearStickPattern, text: "Automatic" },
    ],
  },
  {
    id: "ATV6",
    name: "ATV - Premium",
    subtitle: "Yamaha Grizzly Or Similar.",
    category: "atv",
    tiers: ["elite"],
    tag: "Fully Equipped",
    image: "images/vehicles/grizzly700_2.png",
    highlights: [
      { icon: PiEngineBold, text: "700cc" },
      { icon: GoGear, text: "4x4" },
      { icon: GiGearStickPattern, text: "Automatic" },
    ],
  },
  {
    id: "UTV1",
    name: "UTV - Compact",
    subtitle: "Kawasaki Mule Or Similar.",
    category: "utv",
    tiers: ["explore", "adventure", "elite"],
    tag: "Seats 2",
    image: "images/vehicles/mule400.png",
    highlights: [
      { icon: PiEngineBold, text: "400cc" },
      { icon: GoGear, text: "4x4" },
      { icon: GiGearStickPattern, text: "Automatic" },
    ],
  },
  {
    id: "UTV2",
    name: "UTV - Compact",
    subtitle: "Yamaha Wolverine Or Similar.",
    category: "utv",
    tiers: ["explore", "adventure", "elite"],
    tag: "Seats 2",
    image: "images/vehicles/wolverine850.png",
    highlights: [
      { icon: PiEngineBold, text: "850cc" },
      { icon: GoGear, text: "4x4" },
      { icon: GiGearStickPattern, text: "Automatic" },
    ],
  },
  {
    id: "UTV3",
    name: "UTV - Recreation",
    subtitle: "Yamaha RMAX Or Similar.",
    category: "utv",
    tiers: ["adventure", "elite"],
    tag: "Seats 2",
    image: "images/vehicles/rspec1000.png",
    highlights: [
      { icon: PiEngineBold, text: "1000cc" },
      { icon: GoGear, text: "4x4" },
      { icon: GiGearStickPattern, text: "Automatic" },
    ],
  },
   {
    id: "UTV4",
    name: "UTV - Recreation",
    subtitle: "Kawasaki Teryx Or Similar.",
    category: "utv",
    tiers: ["adventure", "elite"],
    tag: "Seats 4",
    image: "images/vehicles/teryx4.png",
    highlights: [
      { icon: PiEngineBold, text: "800cc" },
      { icon: GoGear, text: "4x4" },
      { icon: GiGearStickPattern, text: "Automatic" },
    ],
  },
  {
    id: "UTV5",
    name: "UTV - Premium",
    subtitle: "Kawasaki Ridge Crew Or Similar.",
    category: "utv",
    tiers: ["elite"],
    tag: "Seats 6",
    image: "images/vehicles/ridgecrew.png",
    highlights: [
      { icon: PiEngineBold, text: "1000cc" },
      { icon: GoGear, text: "4x4" },
      { icon: GiGearStickPattern, text: "Automatic" },
    ],
  },
   {
    id: "UTV6",
    name: "UTV - Premium",
    subtitle: "Yamaha RMAX 4 Or Similar.",
    category: "utv",
    tiers: ["elite"],
    tag: "Seats 4",
    image: "images/vehicles/rmax41000.png",
    highlights: [
      { icon: PiEngineBold, text: "1000cc" },
      { icon: GoGear, text: "4x4" },
      { icon: GiGearStickPattern, text: "Automatic" },
    ],
  },
  {
    id: "sled-1",
    name: "Snowmobile — Compact",
    subtitle: "Yamaha Venom Or Similar",
    category: "snowmobile",
    tiers: ["explore", "adventure", "elite"],
    tag: "2 Stroke",
    image: "images/vehicles/venom.png",
    highlights: [
       { icon: PiEngineBold, text: "400cc" },
      { icon: MdSnowmobile, text: "121''" },
      { icon: FaUsers, text: "Seats 1" },
    ],
  },
  {
    id: "sled-2",
    name: "Snowmobile — Compact",
    subtitle: "Yamaha Transporter Or Similar",
    category: "snowmobile",
    tiers: ["explore", "adventure", "elite"],
    tag: "2 Stroke",
    image: "images/vehicles/transporter.png",
    highlights: [
       { icon: PiEngineBold, text: "800cc" },
      { icon: MdSnowmobile, text: "146''" },
      { icon: FaUsers, text: "Seats 1" },
    ],
  },
   {
    id: "sled-3",
    name: "Snowmobile — Recreation",
    subtitle: "Yamaha Viper Or Similar",
    category: "snowmobile",
    tiers: ["adventure", "elite"],
    tag: "4 Stroke",
    image: "images/vehicles/viper.png",
    highlights: [
       { icon: PiEngineBold, text: "1049cc" },
      { icon: MdSnowmobile, text: "137''" },
      { icon: FaUsers, text: "Seats 2" },
    ],
  },
   {
    id: "sled-4",
    name: "Snowmobile — Recreation",
    subtitle: "Yamaha Viper Or Similar",
    category: "snowmobile",
    tiers: ["adventure", "elite"],
    tag: "4 Stroke",
    image: "images/vehicles/viper2.png",
    highlights: [
       { icon: PiEngineBold, text: "1049cc" },
      { icon: MdSnowmobile, text: "137''" },
      { icon: FaUsers, text: "Seats 2" },
    ],
  },
  {
    id: "sled-5",
    name: "Snowmobile — Recreation",
    subtitle: "Yamaha SideWinder Or Similar",
    category: "snowmobile",
    tiers: ["elite"],
    tag: "Turbo Charged",
    image: "images/vehicles/sidewinder.png",
    highlights: [
       { icon: PiEngineBold, text: "998cc" },
      { icon: MdSnowmobile, text: "137''" },
      { icon: FaUsers, text: "Seats 1" },
    ],
  },
  {
    id: "sled-6",
    name: "Snowmobile — Recreation",
    subtitle: "Yamaha SideWinder Or Similar",
    category: "snowmobile",
    tiers: ["elite"],
    tag: "Turbo Charged",
    image: "images/vehicles/sidewinder2.png",
    highlights: [
       { icon: PiEngineBold, text: "998cc" },
      { icon: MdSnowmobile, text: "146''" },
      { icon: FaUsers, text: "Seats 1" },
    ],
  },
  {
    id: "boat-1",
    name: "Fish - Compact",
    subtitle: "MirroCraft - 167SC Or Similar",
    category: "boats",
    tiers: ["explore", "adventure", "elite"],
    tag: "Side-Console",
    image: "images/vehicles/167sc.png",
    highlights: [
      { icon: RxRulerHorizontal, text: "16ft" },
      { icon: FaUsers, text: "Seats 6" },
      { icon: PiGaugeThin, text: "60hp" },
    ],
  },
  {
    id: "boat-2",
    name: "Bowrider - Compact",
    subtitle: "Hurricane 188 Or Similar",
    category: "boats",
    tiers: ["explore", "adventure", "elite"],
    tag: "Family Fun",
    image: "images/vehicles/hurricane188.png",
    highlights: [
      { icon: RxRulerHorizontal, text: "18ft" },
      { icon: FaUsers, text: "Seats 10" },
      { icon: PiGaugeThin, text: "150hp" },
    ],
  },
  {
    id: "boat-3",
    name: "Pontoon - Compact",
    subtitle: "Avalon LSZ Or Similar",
    category: "boats",
    tiers: ["explore", "adventure", "elite"],
    tag: "Family Fun",
    image: "images/vehicles/avalonlsz.png",
    highlights: [
      { icon: RxRulerHorizontal, text: "23ft" },
      { icon: FaUsers, text: "Seats 13" },
      { icon: PiGaugeThin, text: "150hp" },
    ],
  },
  {
    id: "boat-4",
    name: "Fish - Recreation",
    subtitle: "G3 164F Or Similar",
    category: "boats",
    tiers: ["adventure", "elite"],
    tag: "Family Fun",
    image: "images/vehicles/g3164f.png",
    highlights: [
      { icon: RxRulerHorizontal, text: "16ft" },
      { icon: FaUsers, text: "Seats 6" },
      { icon: PiGaugeThin, text: "90hp" },
    ],
  },
  {
    id: "boat-5",
    name: "Bowrider - Recreation",
    subtitle: "Campion A20 Or Similar",
    category: "boats",
    tiers: ["adventure", "elite"],
    tag: "Family Fun",
    image: "images/vehicles/campiona20.png",
    highlights: [
      { icon: RxRulerHorizontal, text: "20ft" },
      { icon: FaUsers, text: "Seats 8" },
      { icon: PiGaugeThin, text: "150hp" },
    ],
  },
  {
    id: "boat-6",
    name: "Bowrider - Recreation",
    subtitle: "Saxdor 200 Or Similar",
    category: "boats",
    tiers: ["adventure", "elite"],
    tag: "Sport Yacht",
    image: "images/vehicles/saxdor200.png",
    highlights: [
      { icon: RxRulerHorizontal, text: "20ft" },
      { icon: FaUsers, text: "Seats 5" },
      { icon: PiGaugeThin, text: "115hp" },
    ],
  },
   {
    id: "boat-7",
    name: "Bowrider - Recreation",
    subtitle: "Capelli Freedom Or Similar",
    category: "boats",
    tiers: ["adventure", "elite"],
    tag: "Centre Console",
    image: "images/vehicles/CapelliFreedom.png",
    highlights: [
      { icon: RxRulerHorizontal, text: "20ft" },
      { icon: FaUsers, text: "Seats 8" },
      { icon: PiGaugeThin, text: "150hp" },
    ],
  },
  {
    id: "boat-8",
    name: "Pontoon - Recreation",
    subtitle: "Godfrey 2286 Or Similar",
    category: "boats",
    tiers: ["adventure", "elite"],
    tag: "Sport Tube",
    image: "images/vehicles/godfrey2286.png",
    highlights: [
      { icon: RxRulerHorizontal, text: "22ft" },
      { icon: FaUsers, text: "Seats 12" },
      { icon: PiGaugeThin, text: "150hp" },
    ],
  },
  {
    id: "boat-9",
    name: "Wake Board - Recreation",
    subtitle: "Super Air Nautique 210 Or Similar",
    category: "boats",
    tiers: ["adventure", "elite"],
    tag: "Wake Board",
    image: "images/vehicles/superAir.png",
    highlights: [
      { icon: RxRulerHorizontal, text: "21ft" },
      { icon: FaUsers, text: "Seats 12" },
      { icon: PiGaugeThin, text: "343hp" },
    ],
  },
  {
    id: "boat-10",
    name: "Fish - Premium",
    subtitle: "Campion EX22DC Or Similar",
    category: "boats",
    tiers: ["elite"],
    tag: "Sport Fish",
    image: "images/vehicles/rage.png",
    highlights: [
      { icon: RxRulerHorizontal, text: "22ft" },
      { icon: FaUsers, text: "Seats 8" },
      { icon: PiGaugeThin, text: "200hp" },
    ],
  },
  {
    id: "boat-11",
    name: "Bowrider - Premium",
    subtitle: "Hurricane 2690 Or Similar",
    category: "boats",
    tiers: ["elite"],
    tag: "Luxury",
    image: "images/vehicles/2690.png",
    highlights: [
      { icon: RxRulerHorizontal, text: "27ft" },
      { icon: FaUsers, text: "Yacht Certified" },
      { icon: PiGaugeThin, text: "425hp" },
    ],
  },
  {
    id: "boat-12",
    name: "Bowrider - Premium",
    subtitle: "Campion A23 Or Similar",
    category: "boats",
    tiers: ["elite"],
    tag: "Luxury",
    image: "images/vehicles/a23.png",
    highlights: [
      { icon: RxRulerHorizontal, text: "24ft" },
      { icon: FaUsers, text: "Seats 10" },
      { icon: PiGaugeThin, text: "380hp" },
    ],
  },
  {
    id: "boat-13",
    name: "Bowrider - Premium",
    subtitle: "Parker 690 Or Similar",
    category: "boats",
    tiers: ["elite"],
    tag: "Luxury",
    image: "images/vehicles/parker690.png",
    highlights: [
      { icon: RxRulerHorizontal, text: "23ft" },
      { icon: FaUsers, text: "Seats 7" },
      { icon: PiGaugeThin, text: "250hp" },
    ],
  },
  {
    id: "boat-14",
    name: "Pontoon - Premium",
    subtitle: "Godfrey Aqua Patio 235 Or Similar",
    category: "boats",
    tiers: ["elite"],
    tag: "Luxury",
    image: "images/vehicles/235ap.png",
    highlights: [
      { icon: RxRulerHorizontal, text: "24ft" },
      { icon: FaUsers, text: "Seats 7" },
      { icon: PiGaugeThin, text: "250hp" },
    ],
  },
  {
    id: "boat-15",
    name: "Wake Board - Premium",
    subtitle: "Godfrey Or Similar",
    category: "boats",
    tiers: ["elite"],
    tag: "Luxury",
    image: "images/vehicles/ws23.png",
    highlights: [
      { icon: RxRulerHorizontal, text: "24ft" },
      { icon: FaUsers, text: "Seats 8" },
      { icon: PiGaugeThin, text: "380hp" },
    ],
  },
  {
    id: "watercraft1",
    name: "Watercraft - Compact",
    subtitle: "Yamaha Jet Blaster Or Similar",
    category: "watercraft",
    tiers: ["explore", "adventure", "elite"],
    tag: "Sporty",
    image: "images/vehicles/jetblaster.png",
    highlights: [
      { icon: RxRulerHorizontal, text: "10ft" },
      { icon: FaUsers, text: "Seats 3" },
      { icon: PiGaugeThin, text: "110hp" },
    ],
  },
  {
    id: "watercraft2",
    name: "Watercraft - Compact",
    subtitle: "Yamaha Jet Blaster Or Similar",
    category: "watercraft",
    tiers: ["explore", "adventure", "elite"],
    tag: "Sporty",
    image: "images/vehicles/jetblaster2.png",
    highlights: [
      { icon: RxRulerHorizontal, text: "10ft" },
      { icon: FaUsers, text: "Seats 3" },
      { icon: PiGaugeThin, text: "110hp" },
    ],
  },
  {
    id: "watercraft3",
    name: "Watercraft - Recreation",
    subtitle: "Yamaha VX Or Similar",
    category: "watercraft",
    tiers: ["adventure", "elite"],
    tag: "Sporty",
    image: "images/vehicles/vx.png",
    highlights: [
      { icon: RxRulerHorizontal, text: "11ft" },
      { icon: FaUsers, text: "Seats 3" },
      { icon: PiGaugeThin, text: "125hp" },
    ],
  },
  {
    id: "watercraft4",
    name: "Watercraft - Recreation",
    subtitle: "Yamaha VX Or Similar",
    category: "watercraft",
    tiers: ["adventure", "elite"],
    tag: "Sporty",
    image: "images/vehicles/vx2.png",
    highlights: [
      { icon: RxRulerHorizontal, text: "11ft" },
      { icon: FaUsers, text: "Seats 3" },
      { icon: PiGaugeThin, text: "200hp" },
    ],
  },
  {
    id: "watercraft5",
    name: "Watercraft - Premium",
    subtitle: "Yamaha FX Cruiser Or Similar",
    category: "watercraft",
    tiers: ["elite"],
    tag: "Sporty",
    image: "images/vehicles/fx.png",
    highlights: [
      { icon: RxRulerHorizontal, text: "11ft" },
      { icon: FaUsers, text: "Seats 3" },
      { icon: PiGaugeThin, text: "125hp" },
    ],
  },
  {
    id: "watercraft6",
    name: "Watercraft - Premium",
    subtitle: "Yamaha FX Cruiser Or Similar",
    category: "watercraft",
    tiers: ["elite"],
    tag: "Sporty",
    image: "images/vehicles/fx2.png",
    highlights: [
      { icon: RxRulerHorizontal, text: "11ft" },
      { icon: FaUsers, text: "Seats 3" },
      { icon: PiGaugeThin, text: "125hp" },
    ],
  },
  {
    id: "tt-1",
    name: "Travel Trailer — Compact",
    subtitle: "Springdale 1790FQ Or Similar",
    category: "travelTrailers",
    tiers: ["explore", "adventure", "elite"],
    tag: "Rear Bath",
    image: "images/vehicles/1790.png",
    highlights: [
      { icon: FaTrailer, text: "Towable" },
      { icon: FaUsers, text: "Sleeps 4" },
      { icon: RxRulerHorizontal, text: "21ft" },
    ],
  },
  {
    id: "tt-2",
    name: "Travel Trailer — Compact",
    subtitle: "Springdale 1800BH Or Similar",
    category: "travelTrailers",
    tiers: ["explore", "adventure", "elite"],
    tag: "Bunk House",
    image: "images/vehicles/1800.png",
    highlights: [
      { icon: FaTrailer, text: "Towable" },
      { icon: FaUsers, text: "Sleeps 5" },
      { icon: RxRulerHorizontal, text: "21ft" },
    ],
  },
  {
    id: "tt-3",
    name: "Travel Trailer — Compact",
    subtitle: "Prowler 17RBX Or Similar",
    category: "travelTrailers",
    tiers: ["explore", "adventure", "elite"],
    tag: "Rear Bath",
    image: "images/vehicles/17rbx.png",
    highlights: [
      { icon: FaTrailer, text: "Towable" },
      { icon: FaUsers, text: "Sleeps 4" },
      { icon: RxRulerHorizontal, text: "23ft" },
    ],
  },
  {
    id: "tt-4",
    name: "Travel Trailer — Recreation",
    subtitle: "Trail Blazer 1869 Or Similar",
    category: "travelTrailers",
    tiers: ["adventure", "elite"],
    tag: "Rear Bath",
    image: "images/vehicles/1869.png",
    highlights: [
      { icon: FaTrailer, text: "Towable" },
      { icon: FaUsers, text: "Sleeps 4" },
      { icon: RxRulerHorizontal, text: "24ft" },
    ],
  },
  {
    id: "tt-5",
    name: "Travel Trailer — Recreation",
    subtitle: "Trail Blazer 1669 Or Similar",
    category: "travelTrailers",
    tiers: ["adventure", "elite"],
    tag: "Rear Bath",
    image: "images/vehicles/1669.png",
    highlights: [
      { icon: FaTrailer, text: "Towable" },
      { icon: FaUsers, text: "Sleeps 4" },
      { icon: RxRulerHorizontal, text: "22ft" },
    ],
  },
  {
    id: "tt-6",
    name: "Travel Trailer — Recreation",
    subtitle: "Cherokee Wolfden Or Similar",
    category: "travelTrailers",
    tiers: ["adventure", "elite"],
    tag: "Bunk House",
    image: "images/vehicles/wolfden.png",
    highlights: [
      { icon: FaTrailer, text: "Towable" },
      { icon: FaUsers, text: "Sleeps 8" },
      { icon: RxRulerHorizontal, text: "32ft" },
    ],
  },
  {
    id: "tt-7",
    name: "Travel Trailer — Recreation",
    subtitle: "Fuzion Toy Hauler Or Similar",
    category: "travelTrailers",
    tiers: ["adventure", "elite"],
    tag: "Toy Hauler",
    image: "images/vehicles/fuzion.png",
    highlights: [
      { icon: FaTrailer, text: "Towable" },
      { icon: FaUsers, text: "Sleeps 8" },
      { icon: RxRulerHorizontal, text: "32ft" },
    ],
  },
  {
    id: "tt-8",
    name: "Travel Trailer — Premium",
    subtitle: "SportTrek 291VTQ Or Similar",
    category: "travelTrailers",
    tiers: ["elite"],
    tag: "Bunk House",
    image: "images/vehicles/291.png",
    highlights: [
      { icon: FaTrailer, text: "Towable" },
      { icon: FaUsers, text: "Sleeps 10" },
      { icon: RxRulerHorizontal, text: "34ft" },
    ],
  },
  {
    id: "tt-9",
    name: "Travel Trailer — Premium",
    subtitle: "Stratus 211VBH Or Similar",
    category: "travelTrailers",
    tiers: ["elite"],
    tag: "Bunk House",
    image: "images/vehicles/211.png",
    highlights: [
      { icon: FaTrailer, text: "Towable" },
      { icon: FaUsers, text: "Sleeps 6" },
      { icon: RxRulerHorizontal, text: "25ft" },
    ],
  },
  {
    id: "tt-10",
    name: "Travel Trailer — Premium",
    subtitle: "Stratus 241VRK Or Similar",
    category: "travelTrailers",
    tiers: ["elite"],
    tag: "Bunk House",
    image: "images/vehicles/211.png",
    highlights: [
      { icon: FaTrailer, text: "Towable" },
      { icon: FaUsers, text: "Sleeps 6" },
      { icon: RxRulerHorizontal, text: "28ft" },
    ],
  },
  {
    id: "golfCart1",
    name: "Drive 2",
    subtitle: "Drive 2 Or Similar",
    category: "golfCart",
    tiers: ["explore", "adventure", "elite"],
    tag: "Gas",
    image: "https://tbmxmxpcuizrlrkkqmmm.supabase.co/storage/v1/object/public/Vehicles/26571.jpg",
    highlights: [
      { icon: PiGaugeThin, text: "357cc" },
      { icon: FaUsers, text: "Seats 2" },
      { icon: RxRulerHorizontal, text: "93.6 in" },
    ],
  },
  {
    id: "golfCart2",
    name: "UMAX Rally",
    subtitle: "UMAX Rally Or Similar",
    category: "golfCart",
    tiers: ["adventure", "elite"],
    tag: "Gas",
    image: "https://tbmxmxpcuizrlrkkqmmm.supabase.co/storage/v1/object/public/Vehicles/umaxRally.jpeg",
    highlights: [
      { icon: PiGaugeThin, text: "357cc" },
      { icon: FaUsers, text: "Seats 2" },
      { icon: RxRulerHorizontal, text: "118.1 in" },
    ],
  },
  {
    id: "golfCart3",
    name: "Green Works",
    subtitle: "Greenworks Or Similar",
    category: "golfCart",
    tiers: ["elite"],
    tag: "Electric",
    image: "https://tbmxmxpcuizrlrkkqmmm.supabase.co/storage/v1/object/public/Vehicles/Screenshot%202026-03-09%20at%203.06.53%20PM.png",
    highlights: [
      { icon: IoMdBatteryCharging, text: "82V" },
      { icon: FaUsers, text: "Seats 2" },
      { icon: RxRulerHorizontal, text: "105.8 in" },
    ],
  },
];


const TIER_LABELS = {
  all: "All",
  explore: "Explore",
  adventure: "Adventure",
  elite: "Elite",
};

const CATEGORY_LABELS = {
  all: "All",
  travelTrailers: "Travel Trailers",
  boats: "Boats",
  watercraft: "Watercraft",
  atv: "ATV",
  utv: "UTV",
  golfCart: "Golf Cart",
  snowmobile: "Snowmobile",
};


function Pill({ active, onClick, children }) {
  return (
    <button
      type="button"
      className={`pill ${active ? "is-active" : ""}`}
      onClick={onClick}
    >
      {children}
    </button>
  );
}

export default function VehiclesPage() {
  const [tierFilter, setTierFilter] = useState("all"); // all | explorer | adventure | elite
  const [categoryFilter, setCategoryFilter] = useState("all"); // all | travelTrailers | boats | watercraft | atv | utv | golfCart | snowmobile

  const filtered = useMemo(() => {
    return VEHICLES.filter((v) => {
      const tierOk = tierFilter === "all" ? true : v.tiers.includes(tierFilter);
      const catOk = categoryFilter === "all" ? true : v.category === categoryFilter;
      return tierOk && catOk;
    });
  }, [tierFilter, categoryFilter]);

  return (
    <div className="vehPage">
      <header className="vehHero">
       
      </header>

      <main className="vehMain">
        <section className="section">
          <div className="container">
            <div className="section__head">
              <div>
                <h2 className="section__title">Choose Your Adventure</h2>
                <p className="section__subtitle">Filter by club level and category.</p>
              </div>

              <div className="vehTools" aria-label="Filters">
                <div className="vehTools__group" aria-label="Tier filter">
                  <span className="vehTools__label">Club</span>
                  <div className="vehTools__pills">
                    {Object.keys(TIER_LABELS).map((key) => (
                      <Pill
                        key={key}
                        active={tierFilter === key}
                        onClick={() => setTierFilter(key)}
                      >
                        {TIER_LABELS[key]}
                      </Pill>
                    ))}
                  </div>
                </div>

                <div className="vehTools__group" aria-label="Category filter">
                  <span className="vehTools__label">Category</span>
                  <div className="vehTools__pills">
                    {Object.keys(CATEGORY_LABELS).map((key) => (
                      <Pill
                        key={key}
                        active={categoryFilter === key}
                        onClick={() => setCategoryFilter(key)}
                      >
                        {CATEGORY_LABELS[key]}
                      </Pill>
                    ))}
                  </div>
                </div>
              </div>
            </div>

            <div className="vehGrid" aria-label="Vehicle cards">
              {filtered.map((v) => (
                <article key={v.id} className="vehCard">
                  <div className="vehCard__media">
                    <img
                      className="vehCard__img"
                      src={v.image}
                      alt={v.name}
                      loading="lazy"
                      onError={(e) => {
                        e.currentTarget.src = "/images/vehicle-fallback.jpg";
                      }}
                    />
                    <div className="vehCard__tag">{v.tag}</div>
                    <div className="vehCard__cat">{CATEGORY_LABELS[v.category]}</div>
                  </div>

                  <div className="vehCard__body">
                    <h3 className="vehCard__title">{v.name}</h3>

{v.subtitle && (
  <p className="vehCard__subtitle">{v.subtitle}</p>
)}


                    <ul className="vehCard__specs">
  {(v.highlights || []).slice(0, 3).map(({ icon: Icon, text }) => (
    <li key={text}>
      <Icon aria-hidden />
      <span>{text}</span>
    </li>
  ))}
</ul>



                    <div className="vehCard__actions">
                      <a className="btn btn--primary vehCard__cta" href="/#join">
                        Check availability
                      </a>
                    </div>
                  </div>
                </article>
              ))}
            </div>

            {filtered.length === 0 && (
              <div className="vehEmpty" role="status" aria-live="polite">
                No units match those filters. Try “All” or switch category.
              </div>
            )}
          </div>
        </section>
      </main>
    </div>
  );
}
